module.exports = __webpack_public_path__ + "img/new1.a5a39d55.png";